import React from "react";
import styled from "styled-components";

type LiProps = {
  children: React.ReactNode;
};

export const Li = ({ children }: LiProps) => {
  return <StyledLi>{children}</StyledLi>;
};

const StyledLi = styled.li`
  font: var(--body-medium-400);
  color: var(--text-gray-8);
  & > b {
    font: var(--body-medium-600);
  }
`;
